import script from "./webView.vue?vue&type=script&setup=true&lang=js"
export * from "./webView.vue?vue&type=script&setup=true&lang=js"

import "./webView.vue?vue&type=style&index=0&id=9bafa080&scoped=true&lang=less"

import exportComponent from "/data/jenkins_home/workspace/prod-AI-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9bafa080"]])

export default __exports__